__turbopack_context__.v({
  "featuredStepTitle": "UB8YVG_featuredStepTitle",
  "step": "UB8YVG_step",
  "stepDescription": "UB8YVG_stepDescription",
  "stepTitle": "UB8YVG_stepTitle",
  "stepsWrapper": "UB8YVG_stepsWrapper",
  "textContent": "UB8YVG_textContent",
});
